import { IServiceRequestModel } from '../../../../models/index';
import {
  clearServiceDetails,
  createServiceFail,
  createServiceStarted,
  createServiceSuccess
} from '../../../reducer/services/ServiceReducer';
import { createService } from '../../actionType/services/ServiceActionTypes';
import {
  ClearServiceDetails, CreateServiceFailure,
  CreateServiceFailurePayload,
  CreateServiceRequest,
  CreateServiceStarted,
  CreateServiceSuccess,
  CreateServiceSuccessPayload
} from '../../types/services/CreateUpdatedServiceTypes';

export const createServiceRequest = (
  reqObject: IServiceRequestModel
): CreateServiceRequest => ({
  type: createService.CREATE_SERVICE,
  requestObject: { ...reqObject }
});

/**
 * Create service started saga action
 * @returns service started action
 */
export const createServiceStart = (): CreateServiceStarted => ({
  type: createServiceStarted.type
});

/**
 * Create service success saga action
 * @param payload :Service data
 * @returns success action
 */
export const createServiceSuccessful = (
  payload: CreateServiceSuccessPayload
): CreateServiceSuccess => ({
  type: createServiceSuccess.type,
  payload
});

/**
 * Create Service Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const createServiceFailure = (
  payload: CreateServiceFailurePayload
): CreateServiceFailure => ({
  type: createServiceFail.type,
  payload
});

/**
 * Clear Service saga action
 */
export const clearServiceData = (): ClearServiceDetails => ({
  type: clearServiceDetails.type
});
